export default class Deadline {
    constructor({
        id = null,
        date = '',
        evaluation_type = '',
        homework_id = null
    }) {
        this.id = id;
        this.date = date;
        this.evaluation_type = evaluation_type;
        this.homework_id = homework_id;
    }

    // Basic validation for deadline data
    static validate(deadlineData) {
        if (!deadlineData.date) {
            throw new Error('Date is required');
        }
        if (!deadlineData.evaluation_type) {
            throw new Error('Evaluation type is required');
        }
        if (!Deadline.evaluationTypes.includes(deadlineData.evaluation_type)) {
            throw new Error('Invalid evaluation type');
        }
        if (!deadlineData.homework_id) {
            throw new Error('Homework ID is required');
        }
    }

    static normalizeDeadlineDate(dateStr) {
        // Create a date from the input and set time to end of day UTC
        const date = new Date(dateStr);
        date.setUTCHours(23, 59, 59, 999);
        return date.toISOString();
    }

    // Format date to DD.MM.YYYY
    static formatDate(datetime) {
        const date = new Date(datetime);
        return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`;
    }

    // Format date to DD.MM.YYYY HH:MM
    static formatDateTime(date) {
        if (typeof date !== 'string') {
            if (date instanceof Date && !isNaN(date)) {
                date = date.toISOString();
            } else {
                try {
                    date = new Date(date).toISOString();
                } catch (e) {
                    console.error('Invalid date:', date);
                    return '';
                }
            }
        }
        if (!date) return '';

        const [datePart, timePart] = date.split('T');
        const [year, month, day] = datePart.split('-');
        const [hour, minute] = timePart.split(':').map(part => part.split('.')[0]);

        return `${day}.${month}.${year} ${hour}:${minute}`;
    }

    static formatDateForInput(date) {
        return date ? date.split('T')[0] : '';
    }

    // Evaluation types
    static get evaluationTypes() {
        return ['pre', 'post', 'submission', 'manual'];
    }

    static sortDeadlinesByDate(deadlines) {
        return deadlines.sort((a, b) => new Date(a.date) - new Date(b.date));
    }

    static getEvaluationTypeLabel(type) {
        switch(type) {
            case 'pre':
                return 'Pre-evaluation';
            case 'post':
                return 'Post-evaluation';
            case 'submission':
                return 'Submission';
            case 'manual':
                return 'Manual';
            default:
                return type;
        }
    }
}